module.exports = __webpack_public_path__ + "static/media/01_design_agd-comptoir-logo.1fa51200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-comptoir-logo.jpg
// module id = 50
// module chunks = 0